import { useEffect, useState } from "react";
import { useCallback } from "react";

export const FilterAvailability = (props) => {
    const [options, setOptions] = useState([]);
    
    const getOptionComponent = useCallback((optionValue) => {
        const id = "cb_" + props.filter.contentUId + "_" + optionValue;
        const name = "cb_" + props.filter.contentUId;
        var defaultValue = null;
        if (props.filter.IsAvailable === null || props.filter.IsAvailable === undefined) {
            defaultValue = props.dictionary.showAll;
        }
        else if (props.filter.IsAvailable) {
            defaultValue = props.dictionary.available;
        }
        else if (!props.filter.IsAvailable) {
            defaultValue = props.dictionary.unavailable;
        }

        return <div key={props.filter.contentUId + "_" + optionValue} className="c-radio">

            <label htmlFor={id}>

                <input 
                    id={id} 
                    name={name} 
                    value={optionValue} 
                    defaultChecked={optionValue === defaultValue} 
                    type="radio" 
                    onChange={(evt) => {

                        if (evt.target.checked) {
                            switch (optionValue) {
                                case props.dictionary.showAll:
                                    props.filter.IsAvailable = null;
                                    break;
                                case props.dictionary.available:
                                    props.filter.IsAvailable = true;
                                    break;
                                case props.dictionary.unavailable:
                                    props.filter.IsAvailable = false;
                                    break;
                            }

                            let newState = { ...props.ficheData };

                            props.setFicheData(prev => {

                                return {
                                    ...prev,
                                    filter: newState.filter
                                }

                            });
                        }
                    }} 
                />
                {optionValue}
            </label>

        </div>
    }, [JSON.stringify(props.ficheData.filter)]);


    useEffect(() => {
        var options = [];
        options.push(getOptionComponent(props.dictionary.showAll));
        options.push(getOptionComponent(props.dictionary.available));
        options.push(getOptionComponent(props.dictionary.unavailable));

        setOptions(options);
    }, []);

    return <div className={`col-sm-${props.filter.gridWidth != 0 ? props.filter.gridWidth : 4}`}>
        <strong>{props.filter.title}</strong>
        {options}
    </div>;
}